module.exports = __webpack_public_path__ + "static/media/payment_success.ae4b8222.svg";